export default {
  LeftMenu: {
    Control: 'Control',
    EmployeeList: 'Nhân viên',
    CollapseText: 'Thu gọn',
    InventoryItem: 'Kho',
    Account: 'Tài khoản',
    Dashboard: 'Tổng quan',
    Treasury: 'Kho bạc',
    Etreasury: 'Kho bạc điện tử',
    CA: 'Tiền mặt',
    BA: 'Tiền gửi',
    SU: 'Công cụ dụng cụ',
    FA: 'Tài sản cố định',
    Salary: 'Tiền lương',
    PU: 'Mua hàng',
    SA: 'Bán hàng',
    Invoice: 'Hóa đơn',
    Tax: 'Thuế',
    GL: 'Tổng hợp',
    Report: 'Báo cáo',
  },
  Nav: {
    PostedDate: 'Ngày hạch toán:',
    Search: 'Tìm chứng từ',
  },
};
